import { useEffect, useState } from "react";
import styles from "./index.module.css";
import { classNames } from "../../tool";

export default function ActionSheet(props) {
  const [status, setStatus] = useState("");
  useEffect(() => {
    if (props.visible) {
      setStatus("show");
    } else {
      if (status) {
        setStatus("animate");
        setTimeout(() => {
          setStatus("hide");
        }, 400);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible]);

  return status === "show" || status === "animate" ? (
    <div
      className={`${styles.actionSheet} ${
        status === "animate" ? styles.animate : ""
      }`}
      onClick={() => {
        props.close();
      }}
    >
      <div
        className={classNames(styles.content, props.className)}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {props.children}
      </div>
    </div>
  ) : null;
}
